import { RsHTMLElement } from '../rs-htmlelement.js';
import styles from 'inline:./rs-generated-answer.scss';
import injectedStyles from 'inline:./rs-generated-answer-inject.scss';

export class RsGeneratedAnswer extends RsHTMLElement {
    styles() {
        return styles;
    }

    async mounted() { 
        await this.waitForAtomicGeneratedAnswer();

        this.injectElements();
        this.injectAtomicStyleSheets();
    }

    get atomicGeneratedAnswer() {
        return this.shadow.querySelector('atomic-generated-answer');
    }

    get atomicAnswerShowButton() {
        return this.atomicGeneratedAnswer?.shadowRoot?.querySelector('[part="answer-show-button"]');
    }

    injectAtomicStyleSheets() {
        this.addStyles(injectedStyles, this.atomicGeneratedAnswer.shadowRoot);
    }

    async injectElements() {
        const answerShowButtonInterval = setInterval(() => {
            if (!this.atomicAnswerShowButton) {
                return;
            }

            clearInterval(answerShowButtonInterval);
            this.atomicAnswerShowButton.querySelector('atomic-icon')?.remove();

            const iconsWrapper = document.createElement('div');
            iconsWrapper.classList.add('icons-wrapper');

            const moreIcon = document.createElement('div');
            moreIcon.classList.add('more-icon');
            moreIcon.innerHTML = `
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path id="Vector" d="M7.99992 3.33337V12.6667M3.33325 8.00004H12.6666" stroke="current" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            `;

            const lessIcon = document.createElement('div');
            lessIcon.classList.add('less-icon');
            lessIcon.innerHTML = `
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.33325 8H12.6666" stroke="current" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>            
            `;

            iconsWrapper.appendChild(lessIcon);
            iconsWrapper.appendChild(moreIcon);
            this.atomicAnswerShowButton.appendChild(iconsWrapper);
        }, 10);
    }

    async waitForAtomicGeneratedAnswer() {
        await customElements.whenDefined('atomic-generated-answer');

        return new Promise((resolve) => {
            const interval = setInterval(() => {
                /*
                    The generated answer is fully loaded once the shadow root has children
                */
                if (this.atomicGeneratedAnswer.shadowRoot?.children.length) {
                    clearInterval(interval);
                    resolve();
                }
            }, 15);
        });
    }

    render() {
        this.shadow.innerHTML = `<atomic-generated-answer></atomic-generated-answer>`;
    }
};